import script from "./reportYsjh.vue?vue&type=script&setup=true&lang=js"
export * from "./reportYsjh.vue?vue&type=script&setup=true&lang=js"

import "./reportYsjh.vue?vue&type=style&index=0&id=2f9d603a&lang=less"

const __exports__ = script;

export default __exports__